const KST_TIME_ZONE = 'Asia/Seoul';

export function parseServerDate(value?: string | null): Date | null {
    if (!value) return null;
    const base = value.trim().replace(' ', 'T').replace(/\.(\d{3})\d+/, '.$1');
    const normalized = /[zZ]|[+-]\d{2}:\d{2}$/.test(base) ? base : `${base}Z`;
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function formatKstDateTime(value?: string | null): string {
    const d = parseServerDate(value);
    if (!d) return '-';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    }).format(d);
}

export function formatKstDate(value?: string | null): string {
    const d = parseServerDate(value);
    if (!d) return '-';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(d);
}

export function toKstDateTimeInputValue(value?: string | null): string {
    const d = parseServerDate(value);
    if (!d) return '';
    const parts = new Intl.DateTimeFormat('sv-SE', {
        timeZone: KST_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(d);
    const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

export function nowKstDateTimeInputValue(): string {
    return toKstDateTimeInputValue(new Date().toISOString());
}

export function kstInputToUtcLocalDateTime(value?: string): string | undefined {
    if (!value) return undefined;
    const withOffset = `${value}:00+09:00`;
    const d = new Date(withOffset);
    if (Number.isNaN(d.getTime())) return undefined;
    // Backend(LocalDateTime)로 보낼 때 UTC 기준 wall time 문자열 사용
    return d.toISOString().slice(0, 19);
}
